/* unplugin-vue-components disabled */
export default {
  mixins: [
    ModelValue(String)
  ],
  props: {
    title: {type: String, default: undefined},
    placeholder: {type: String, default: undefined}
  }
}
